import React from "react";

function SuccessScreen({ plate, carModel }) {
  return (
    <section className="card success-screen">
      <div className="status-icon status-icon-success">✓</div>
      <h2>Teslim Alma İsteğiniz Gönderildi!</h2>
      <p className="status-copy">
        Aracınız en kısa sürede size teslim edilecektir.
      </p>

      <div className="vehicle-summary">
        <div>
          <span className="summary-label">Plaka</span>
          <strong>{plate}</strong>
        </div>
        <div>
          <span className="summary-label">Marka / Model</span>
          <strong>{carModel}</strong>
        </div>
      </div>
    </section>
  );
}

export default SuccessScreen;
